/**
 * The two URL routes this story adds to the client (AD-794 §6.2, §6.4). Pure over the URL parts.
 *
 *   - `?guest=1` — the `try.` host's "Play now" boot path: skip the auth and select screens and
 *     start a guest. On the main origin the guest routes are absent (404), so the same URL falls
 *     back to the normal auth screen with a one-line notice (`guestFlow.ts` `unavailable`).
 *   - `?from=demo` (or `#/register`) — the end card's "Create your account" lands on the main
 *     client's REGISTER mode directly; before this there was no URL to it at all (only the
 *     `AuthScreen` toggle). `?from=demo` is a one-bit acquisition hint; carrying it into the
 *     register request body is S7b's (`account_created.source`), not this story's.
 */

function params(search: string): URLSearchParams {
  return new URLSearchParams(search.startsWith('?') ? search.slice(1) : search);
}

/** `?guest=1` asks for the guest demo boot path. */
export function guestBootRequested(search: string): boolean {
  return params(search).get('guest') === '1';
}

/** The auth screen's first mode for this URL: `register` for `?from=demo` / `#/register`. */
export function initialAuthMode(search: string, hash: string): 'login' | 'register' {
  if (params(search).get('from') === 'demo') return 'register';
  return hash === '#/register' ? 'register' : 'login';
}
